"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getAddressLineString = function (address) {
    if (address === void 0) { address = {}; }
    if (address.addressLine1 && address.addressLine2) {
        return "".concat(address.addressLine1, ", ").concat(address.addressLine2);
    }
    return address.addressLine1 || '';
};
exports.default = getAddressLineString;
